exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/components/shared/sidebar/sidebar.component.css
// module id = ../../../../../src/app/components/shared/sidebar/sidebar.component.css
// module chunks = 1